@if (telematicsWarning(); as warning) {
  <onyx-message intent="error">
    <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

    {{ `${I18N}.${warning}` | translate }}

    <onyx-button
      variant="ghost"
      [size]="32"
      [routerLink]="IntegrationsRoute.INTEGRATIONS_LIST"
      (click)="close$().next()"
    >
      {{ 'labels.settings' | translate }}
    </onyx-button>
  </onyx-message>
}

<ng-container
  *ngTemplateOutlet="warningsTemplate; context: { type: 'error' }"
></ng-container>

<ng-container
  *ngTemplateOutlet="warningsTemplate; context: { type: 'warning' }"
></ng-container>

<ng-template let-type="type" #warningsTemplate>
  @let data =
    type === 'error' ? expiryStatuses().errors : expiryStatuses().warnings;
  @if (data.length; as count) {
    @let item = count === 1 ? data[0] : null;
    <app-fleet-modal-warning
      [type]="type"
      [expiryDate]="item?.expiryDate"
      [label]="item?.key"
      [count]="item ? undefined : count"
      (redirect)="
        item?.key === 'tachographLegalization'
          ? redirectToDetails.emit()
          : redirectToDocuments.emit()
      "
    ></app-fleet-modal-warning>
  }
</ng-template>
